<template>
  <!-- <v-dialog elevation="4" width="80%" persistent> -->
  <v-card
    class="mt-5 px-2 fill-height"
    v-model="dialog"
    elevation="0"
  >
    <v-btn
      v-if="!loading"
      @click="close"
      elevation="0"
      class="trns"
      absolute
      fab
      x-small
      title="Close Debugger"
    >
      <v-icon size="25">mdi-close-circle</v-icon>
    </v-btn>
    <result-layout
      :result="result"
      :height="65"
      :debugging="true"
      :loading="loading"
      @close="closeView"
    />
    <!-- <section>
      <Loader v-if="loading" :active="loading" />
    </section> -->
    <!-- <section class="absolute fw">
      <v-progress-linear
        class="mt-1 fixed loader"
        rounded
        :value="50"
        height="16"
      >
        <strong> {{ Math.ceil(50) }}% </strong>
      </v-progress-linear>
    </section> -->
  </v-card>
  <!-- </v-dialog> -->
</template>

<script lang="ts">
import { Result } from "@/types";
import { genCancelToken } from "@/utils/fetcher";
import { CancelTokenSource } from "axios";
import Vue from "vue";
import VueTypes from "vue-types";
import ResultLayout from "./ResultLayout.vue";

export default Vue.extend({
  components: {  ResultLayout },
  name: "DebuggerView",

  data() {
    return {
      ct: this.cancelTokenSource as CancelTokenSource,
    };
  },
  props: {
    plan: VueTypes.any,
    cancelTokenSource: VueTypes.any,
    isolated: VueTypes.bool.def(false),
    loading: VueTypes.bool.def(false),
  },
  computed: {
    dialog(): boolean {
      return this.$store.getters["Plans/getPlanDisplayDebugger"];
    },
    result(): Result {
      return this.$store.getters["Plans/getPlanCurrentDebugger"];
    },
    cancelToken: {
      get(): CancelTokenSource {
        return this.ct;
      },
      set(val: CancelTokenSource) {
        this.ct = val;
      },
    },
  },
  methods: {
    closeView(): void {
      this.$store.commit("Results/setCurrentResultView");
    },
    close() {
      this.closeView();
      this.$store.commit("Plans/setPlanDisplayDebugger", false);
      this.$store.commit("Results/setCurrentResultView");
      this.$store.commit("Plans/setPlanCurrentDebugger");
    },
    async runPlan() {
      this.$store.commit("Results/setCurrentResultView");
      this.$store.commit("Plans/setPlanCurrentDebugger");
      this.cancelToken = genCancelToken();
      const results = await this.$store.dispatch("Plans/run", {
        id: this.plan._id,
        debug: true,
        cancelToken: this.cancelToken.token,
      });
      this.$store.commit("Plans/setPlanCurrentDebugger", results);
    },
  },
  destroyed() {
    this.cancelToken.cancel();
  },
});
</script>
<style scoped>
#debugger {
  overflow: hidden;
  position: absolute;
  z-index: 999 !important;
  max-height: 100vh !important;
}
/* .fixed {
  top: 0;
}
.loader {
  width: 30%;
  z-index: 9999 !important;
} */
</style>
